import React, { useMemo } from 'react';
import Badge from 'react-bootstrap/Badge';
import classNames from 'classnames';

import styles from './StatusBadge.module.scss';

const PAYMENT_BADGES = {
  due: styles.warningBadge,
  paid: styles.positiveBadge,
  ineligible: styles.neutralBadge,
  past_due: styles.negativeBadge,
  open: styles.infoBadge,
  disputed: styles.urgentBadge,
  blocked: styles.blockedBadge,
  resolved: styles.positiveBadge,
};

const DISPUTE_BADGES = {
  disputed: styles.urgentBadge,
  resolved: styles.positiveBadge,
  respond: styles.warningBadge,
};

const BADGE_TYPES = {
  payment: 'payment',
  dispute: 'dispute',
};

const StatusBadge = ({ value, type, icon: Icon, onClick }) => {
  const badgeStyle = useMemo(() => {
    if (type === BADGE_TYPES.payment) {
      return PAYMENT_BADGES[value];
    }
    if (type === BADGE_TYPES.dispute) {
      return DISPUTE_BADGES[value];
    }
  }, [value]);

  return (
    <div className={styles.container}>
      <Badge className={classNames(styles.badgeContent, badgeStyle, onClick && styles.pointer)} onClick={onClick}>
        {value?.replaceAll('_', ' ')} {Icon && <Icon />}
      </Badge>
    </div>
  );
};

export default StatusBadge;
